import { useTranslation } from 'react-i18next';

import {
  BoxExpand,
  Button,
  ButtonsWrapper,
  CheckboxInput,
  Drawer,
  Form,
} from '@thinknet-gmbh/platform-common-ui';
import { VacancyPatternStatusesEnum } from '@thinknet-gmbh/platform-common';

import { IVacanciesFilter, ITableFilterProps } from 'src/pages/vacancies/vacancies.interfaces';
import { useGetAllPlatformCompanies } from 'src/hooks/companies/get-all-platform-companies.hook';

import { FormContentWrapper } from './vacancies-table-filter.styles';
import { getFilteredData, getInitialFilterData } from './vacancies-table-filter.helpers';

const VacanciesTableFilter = ({ isOpened, onClose, filters, setFilters }: ITableFilterProps) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const { companies } = useGetAllPlatformCompanies();

  const onFinish = (values: any) => {
    setFilters((oldValue: IVacanciesFilter) => ({ ...oldValue, ...getFilteredData(values) }));
    onClose();
  };

  const initialFilterData = getInitialFilterData(filters);

  return (
    <Drawer visible={isOpened} onClose={onClose} title={t('common:buttons.filterBy')}>
      <Form layout="vertical" onFinish={onFinish} initialValues={initialFilterData}>
        <FormContentWrapper>
          <BoxExpand
            title={t('common:labels.companyName')}
            isExpandedWhenEdit={!!filters.companiesIds?.length}
          >
            {companies.map(({ _id, name }: any) => (
              <Form.Item key={_id} name={['companiesIds', _id]} valuePropName="checked">
                <CheckboxInput>{name}</CheckboxInput>
              </Form.Item>
            ))}
          </BoxExpand>
          <BoxExpand
            title={t('vacancies:labels.vacancyStatus')}
            isExpandedWhenEdit={!!filters.statuses?.length}
          >
            {Object.values(VacancyPatternStatusesEnum).map(status => (
              <Form.Item key={status} name={['statuses', status]} valuePropName="checked">
                <CheckboxInput>
                  {t(`vacancies:labels.statusesForFilter.${status.toLowerCase()}`)}
                </CheckboxInput>
              </Form.Item>
            ))}
          </BoxExpand>
          <ButtonsWrapper marginTop={16}>
            <Button type="primary" htmlType="submit">
              {t('common:buttons.apply')}
            </Button>
            <Button
              onClick={() => {
                onClose();
                setFilters({});
              }}
            >
              {t('common:buttons.cancel')}
            </Button>
          </ButtonsWrapper>
        </FormContentWrapper>
      </Form>
    </Drawer>
  );
};

export default VacanciesTableFilter;
